import { useState } from 'react';

import { useDroppedWorkbook } from './useDroppedWorkbook';

/**
 * The files on the page and the supplier they are converted for: the results
 * workbook, the supplier's optional second file, and a dropped file waiting in
 * the supplier dialog until the user says which supplier it is from.
 */
export function useResultsFiles() {
  const results = useDroppedWorkbook();
  const lookup = useDroppedWorkbook();
  const [pickedLayoutId, setPickedLayoutId] = useState<string | null>(null);
  const [pendingFiles, setPendingFiles] = useState<File[]>([]);
  // The second file belongs to the supplier it was dropped for; switching
  // supplier must not convert with another supplier's file.
  const [lookupLayoutId, setLookupLayoutId] = useState<string | null>(null);

  /** The user chose the supplier (and which file is which) for the pending drop. */
  function confirm(
    layoutId: string,
    resultsFile: File,
    lookupFile: File | null,
  ): void {
    void results.readFile(resultsFile);
    if (lookupFile) void lookup.readFile(lookupFile);
    else lookup.clear();
    setLookupLayoutId(lookupFile ? layoutId : null);
    setPickedLayoutId(layoutId);
    setPendingFiles([]);
  }

  // The second file (and any error reading it) belongs to its supplier.
  const lookupIsForPicked =
    lookupLayoutId !== null && lookupLayoutId === pickedLayoutId;
  return {
    workbook: results.workbook,
    sheet: results.workbook?.sheet ?? null,
    /** The results sheet being converted, and the others it can switch to. */
    sheetName: results.workbook?.sheetName ?? null,
    resultsSheetNames: results.workbook?.resultsSheetNames ?? [],
    selectSheet: results.selectSheet,
    lookupSheet: lookupIsForPicked ? (lookup.workbook?.sheet ?? null) : null,
    isReading: results.isReading || lookup.isReading,
    readError:
      results.readError ?? (lookupIsForPicked ? lookup.readError : null),
    pickedLayoutId,
    setPickedLayoutId,
    pendingFiles,
    setPendingFiles,
    confirm,
  };
}
